import * as types from 'modules/campaigns/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import { WS_CAMPAIGN_STATS_UPDATE } from '../sagas/sockets';

/** @typedef {Record<string, import("../types").CampaignStatistics>} CampaignStatisticsReducer */

/** @type {CampaignStatisticsReducer} */
const INITIAL_STATE = {};

/**
 * @param {CampaignStatisticsReducer} state
 * @param {import("../types").FetchCampaignAction} action
 * @returns {CampaignStatisticsReducer}
 */
const updateFromRequest = (state, { payload: campaign }) => {
  if (typeof campaign.statistics === 'object') {
    return {
      ...state,
      [campaign.id]: campaign.statistics,
    };
  }
  return state;
};

/**
 * @param {CampaignStatisticsReducer} state
 * @returns {CampaignStatisticsReducer}
 */
const updateFromSocket = (state, { payload }) => {
  const statistic = payload?.data?.campaignStatistic;
  if (statistic) {
    const { channel, campaignId, modifiedById, createdById, modifiedOn, createdOn, ...cleared } = statistic;
    return {
      ...state,
      [campaignId]: {
        ...state[campaignId],
        [channel]: cleared,
      },
    };
  }
  return state;
};

export default createReducer(INITIAL_STATE, {
  [WS_CAMPAIGN_STATS_UPDATE]: updateFromSocket,
  [types.FETCH_CAMPAIGN_SUCCESS]: updateFromRequest,
});
